// extracted by mini-css-extract-plugin
export default {"summery":"OrderSummery_summery__ov5w4","total":"OrderSummery_total__H-xJa"};